// extracted by mini-css-extract-plugin
export var chevron = "_py-1";
export var clickable = "_py-0";
export var ruleRow = "_py-2";